import { useContext } from 'react';

import { NewElevatorDialogContext } from '../contexts/NewElevatorDialogContext';

export const useNewElevatorDialog = () => useContext(NewElevatorDialogContext);
